import { Component, Renderer2, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { PopUpService } from 'core/index';
import { TranslateService } from '@ngx-translate/core';
import { Payment } from '../models/payment';
import { PaymentsService } from '../services/payments.service';

@Component({
  selector: 'lms-credits-order',
  templateUrl: 'credits-order.component.html'
})
export class CreditsOrderComponent implements OnInit {
  public orderOptions: any;
  public payment: Payment;

  constructor(
    public paymentsService: PaymentsService,
    public renderer: Renderer2,
    public location: Location,
    public route: ActivatedRoute,
    public popupService: PopUpService,
    public translate: TranslateService
  ) {}

  ngOnInit() {
    this.payment = new Payment();
    this.route.data.subscribe((data) => {
      this.orderOptions = data['orderOptions'];
      this.payment.clientId = data['client'].id;
      this.payment.userId = data['user'].id;
      this.payment.clientMail = data['user'].email;
    });
  }

  order(orderPackage) {
    this.payment.amount = orderPackage.amount;
    this.payment.rateLimit = this.payment.amount;
    this.payment.totalCredits = orderPackage.totalCredits;
    this.payment.currency = orderPackage.currency;
    const handler = (window as any).StripeCheckout.configure({
      key: this.orderOptions.publicKey,
      locale: 'auto',
      name: 'GAMELEARN',
      amount: this.payment.amount * 100,
      email: this.payment.clientMail,
      currency: this.payment.currency,
      image: '/public/img/logo.png',
      token: (token: any) => {
        this.payment.token = token.id;
        this.paymentsService.orderCredits(this.payment).subscribe({
          next: () => this.successPopUp(),
          error: (error) => this.errorPopUp(error)
        });
      }
    });

    handler.open();
  }

  successPopUp() {
    this.popupService
      .showConfirm({
        type: 'info',
        title: this.translate.instant('credits.order.success')
      })
      .catch(() => {});
  }

  errorPopUp(error) {
    this.popupService.showError({
      title: this.translate.instant('credits.order.error'),
      text: error.data.message || error.serverMessage
    });
  }

  goBack(): void {
    this.location.back();
  }
}
